import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from 'antd'
import Card from '../../../common/Card'
import $t from '../../../../i18n'
import Actions from '../../../../actions'
import { ACTIVITY_CATEGORIES, routes } from '../../../../consts'
import ActivityItem from '../../../common/ActivityItem'
import EmptyList from '../../../common/EmptyList'
import {
  getActivityListByMember,
  getEnrollmentPaymentNotification,
  getPaymentReceivedNotification
} from 'utils/activityUtils'
import { usePaymentNotifications } from 'hooks'

import './ActivitySection.css'

export const ActivitySection = ({ forwardedRef }) => {
  const dispatch = useDispatch()

  const MAX_NOTIFICATIONS = 4
  const selectedMember = useSelector(state => state.account?.selectedMember)
  const userDetails = useSelector(state => state.profile?.userDetails)

  const {
    showEnrollmentPaymentNotification,
    showPaymentReceivedNotification,
    hasPinnedPaymentNotification
  } = usePaymentNotifications()

  const categorySelected = useSelector(
    state => state?.notifications?.selectedCategory
  )

  const notificationData = useSelector(state =>
    getActivityListByMember(state?.notifications?.notifications, selectedMember)
  )

  const filterList = useSelector(state =>
    getActivityListByMember(
      state?.notifications?.notificationsByCategory,
      selectedMember
    )
  )

  const shouldShowMoreButton = filterList?.length > MAX_NOTIFICATIONS

  const getFilterActions = () =>
    Object.values(ACTIVITY_CATEGORIES).map((category, i) => {
      const selected = categorySelected === category
      const count =
        category === ACTIVITY_CATEGORIES.ALL
          ? notificationData?.length
          : notificationData?.filter(item => item?.category === category)
              ?.length
      return (
        <Button
          type="primary"
          key={i}
          className={
            selected ? 'activity-filter-btn selected' : 'activity-filter-btn'
          }
          onClick={() =>
            dispatch(
              Actions.createAction(
                Actions.NOTIFICATIONS_CATEGORY_CHANGED,
                category
              )
            )
          }
        >
          {!!count
            ? `${$t(`homeScreen.myActivity.categories.${category}`)} (${count})`
            : $t(`homeScreen.myActivity.categories.${category}`)}
        </Button>
      )
    })

  const renderContentByCategory = ({ item, index }) => (
    <ActivityItem item={item} key={index} index={index} />
  )

  return (
    <div className="activity-section" ref={forwardedRef}>
      <div className="section-header">{$t('homeScreen.myActivity.title')}</div>
      <Card className="activity-card">
        <div className="activity-actions-list">{getFilterActions()}</div>
        <div className="activity-list">
          {showEnrollmentPaymentNotification && (
            <ActivityItem
              item={getEnrollmentPaymentNotification(
                true,
                userDetails?.hmo_effective_begin_date
              )}
            />
          )}
          {showPaymentReceivedNotification && (
            <ActivityItem item={getPaymentReceivedNotification()} />
          )}
          {!filterList?.length && !hasPinnedPaymentNotification && (
            <EmptyList title={$t('homeScreen.myActivity.noActivity')} />
          )}
          {!!filterList?.length &&
            filterList
              ?.slice(0, MAX_NOTIFICATIONS)
              ?.map((item, index) => renderContentByCategory({ item, index }))}
          {shouldShowMoreButton && (
            <Button
              onClick={() =>
                dispatch(
                  Actions.createAction(Actions.NAVIGATED_TO, routes.ACTIVITY)
                )
              }
              type="link"
              className="show-more-btn"
            >
              {$t('homeScreen.myActivity.showMore')}
            </Button>
          )}
        </div>
      </Card>
    </div>
  )
}

export default ActivitySection
